export default __webpack_public_path__ + "static/media/DSC_8262-edited.01678141.jpg";